import { ClassNameProps, Column, RelativeTimestamp, Row, StyleProps, TruncatedText } from "@hex-insights/core";
import { SlimTimelineItemLoadingPlaceholder } from "../../../../Components/LoadingPlaceholder";
import { TimelineSchoolAttendanceRecordListQuery } from "../../../../Utilities";
import { AttendanceStatusFormat } from "../../../Format";
import { StudentLink, UserLink } from "../../../Links";
import { AttendanceStatusBadge } from "../../AttendanceStatus";
import styles from "./styles.module.css";

export type TimelineItemProps = {
	isLoading?: boolean;
	schoolAttendanceRecord:
		| TimelineSchoolAttendanceRecordListQuery["schoolAttendanceRecordConnection"]["edges"][0]["node"]
		| null;
} & Partial<ClassNameProps & StyleProps>;

export function TimelineItem({ isLoading = false, schoolAttendanceRecord, className, style }: TimelineItemProps) {
	if (isLoading && !schoolAttendanceRecord) {
		return <SlimTimelineItemLoadingPlaceholder className={className} style={style} />;
	}

	if (!schoolAttendanceRecord) {
		return null;
	}

	return (
		<div className={styles["timeline-item"]}>
			<Row justify="spaced-start" align="center" horizontalSpacing="1rem">
				<AttendanceStatusBadge attendanceStatus={schoolAttendanceRecord.attendanceStatus} />

				<Column justify="spaced-start" verticalSpacing="0.125rem" style={{ width: "100%", minWidth: 0 }}>
					<Row justify="spaced-start">
						<TruncatedText className={styles["timeline-item__main-line"]}>
							{!!schoolAttendanceRecord.author ? (
								<UserLink instance={schoolAttendanceRecord.author} className="link--primary link--no-text-decoration" />
							) : (
								"Deleted User"
							)}{" "}
							took attendance for{" "}
							<StudentLink
								instance={schoolAttendanceRecord.student}
								className="link--primary link--no-text-decoration"
							/>
						</TruncatedText>

						<RelativeTimestamp value={schoolAttendanceRecord.createdAt} className="timestamp nowrap" />
					</Row>

					<TruncatedText className={styles["timeline-item__preview-text"]}>
						{AttendanceStatusFormat.name(schoolAttendanceRecord.attendanceStatus)}
					</TruncatedText>
				</Column>
			</Row>
		</div>
	);
}
